<template>
    <div class="notice-content">
        <car-headerbar title="发布" :isCustomLeft="isCustomLeft"/>
        <!-- <header-back title="发布" @back="dialogCancel"></header-back> -->
        <!-- <me-notice-bar color="rgba(69, 90, 100, 0.6)" background="#f7f7f7">发布设置</me-notice-bar> -->
        <me-cell-group class="defined-group">
            <me-cell class="defined-cell" title="是否匿名" :value="anonymous.text" is-link @click.prevent="showPop('anonymous')"/>
            <me-cell class="defined-cell" title="通知类型" :value="notice.text" is-link @click.prevent="showPop('notice')"/>
            <me-cell v-if="notice.value !== 'MsgExternal'" class="defined-cell" style="margin-bottom: 0px;" title="指定发送范围" :value="haveRange ? '已设置' : '未设置'" @click.prevent="jump" is-link/>
            <div class="defined-span" v-show="notice.value === 'RemindTask'">{{'发送后，问卷将以流程的待办任务的方式，通知到指定人员;'}}</div>
        </me-cell-group>
        <div v-if="notice.value === 'MsgExternal' || notice.value === 'MsgInternal'">
            <me-notice-bar color="rgba(69, 90, 100, 0.6)" background="#f7f7f7">短信签名</me-notice-bar>
            <div>
                <me-cell-group class="defined-group">
                    <me-cell class="defined-cell" title="签名" is-link :value="signType.text" @click.prevent="showPopSign"/>
                    <me-field
                        v-if="signType.value === 'user_custom'"
                        class="defined-field defined-cell"
                        v-model="customSignId"
                        input-align="right"
                        maxlength="50"
                        label="模版服务ID"
                        placeholder="请填写短信平台模版中的服务ID"
                    />
                <div class="desc-tip" v-if="signType.value === 'user_custom'"><span>说明：</span>如内容带有手机号、链接的短信，有被短信供应商拦截风险，请到短信平台申请模版并报备，短信模版选【自定义短信平台模版】</div>
                    <div class="send-tip" v-if="signType.dicValue === 'user_custom'" @click="showTipDesc"><me-icon name="info-o" class="info-o"/>短信模版如何配置？</div>
                </me-cell-group>
            </div>
        </div>
        <div v-if="notice.value && notice.value !== 'RemindTask'">
            <me-notice-bar color="rgba(69, 90, 100, 0.6)" background="#f7f7f7">{{notice.value === 'IMChart' ? '呱呱消息内容' : '短信内容'}}</me-notice-bar>
            <div class="content_text content" v-if="signType.value !== 'user_custom' || notice.value === 'IMChart'">
                <span class="desc">正文中插入：</span>
                <div class="texts">
                    <span @click="insert('手机号')">手机号</span>
                    <span @click="insert('扩展字段2')">扩展字段2</span>
                    <span @click="insert('扩展字段3')">扩展字段3</span>
                    <span @click="insert('扩展字段4')">扩展字段4</span>
                    <span @click="insert('问卷链接')">问卷链接</span>
                </div>
                <div class="tip"><span>注意：</span>请不要修改{{}}中的内容，系统会根据问卷自动替换。</div>
                <me-field
                    ref="textareaContent"
                    v-model="smsContent"
                    label=""
                    placeholder=""
                    title-position="top"
                    type="textarea"
                    maxlength="300"
                    autosize
                    rows="10"
                    show-word-limit
                />
            </div>
            <div v-else>
                <div class="desc-tip" style="padding-top: 10px;"><span>说明：</span>请选择短信平台中自定义短信模版中使用的变量：</div>
                <me-cell-group class="defined-group">
                    <me-cell
                        center
                        :title="item.fieldName"
                        class="defined-cell"
                        v-for="(item, index) in smsContentList"
                        :key="index"
                    >
                        <template #right-icon>
                            <me-switch
                                v-model="item.enabled"
                                active-value="1"
                                inactive-value="0"
                                active-color="#06B455"
                                inactive-color="#DBDBDB"
                                size="24"/>
                        </template>
                    </me-cell>
                </me-cell-group>
            </div>
        </div>
        <confirm
            @confirm="confirm"
            @cancel="dialogCancel"
            :btns="true"
            cancelText="取消"
            :text="notice.value === 'MsgExternal' ? '发布' : '发布并发送'"/>
        <me-popup v-model="showPopup1" round position="bottom">
            <me-picker
                    title="是否匿名"
                    show-toolbar
                    :columns="columns"
                    :default-index="getdefaultIndex('anonymous', anonymous.value)"
                    @confirm="(value) => onConfirmPicker(value, 'anonymous')"
                    @cancel="onCancelPicker"
                    />
        </me-popup>
        <me-popup v-model="showPopup2" round position="bottom" v-if="showPopup2">
            <me-picker
                    title="通知类型"
                    show-toolbar
                    :columns="columnsNotice"
                    :default-index="getdefaultIndex('notice', notice.value)"
                    @confirm="(value) => onConfirmPicker(value, 'notice')"
                    @cancel="onCancelPicker"
                    />
        </me-popup>
        <me-popup v-model="showPopup3" round position="bottom">
            <me-picker
                    title="选择签名"
                    show-toolbar
                    :columns="columnsSign"
                    :default-index="getdefaultIndex('sign', signType.value)"
                    @confirm="(value) => onConfirmPicker(value, 'sign')"
                    @cancel="onCancelPicker"
                    />
        </me-popup>
        <me-dialog 
            v-model="dialogShow"
            title="提示"
            confirm-button-text="查看发送记录"
            cancel-button-text="返回列表"
            :show-cancel-button="showBtn"
            :show-confirm-button="showBtn"
            @confirm="dialogConfirm"
            @cancel="dialogCancel"
            >
            <div class="dialog_msg">
                <span>{{dialogMsg}}</span>
            </div>
        </me-dialog>
    </div>
</template>
<script>

import { addClass2, removeClass2 } from '@/util/status-util'
import { Toast } from '@guazi-fe/melon'
import confirm from '../compontents/confirm.vue'
import { Cell, CellGroup} from '@guazi-fe/melon'
import { Questionnaire } from '@/network'
import { mixin } from '@/mixins'
import browser from '@/util/browser'
import NativeApi from 'native-api'
import { Dialog } from '@guazi-fe/melon'

export default {
    name: 'publish',
    data() {
        return {
            customSignId: '',
            dialogShow: false,
            dialogMsg: '',
            showBtn: false,
            smsContent: '',
            anonymous: {
                text: '',
                value: ''
            },
            notice: {
                text: '',
                value: ''
            },
            signType: {
                text: '',
                value: ''
            },
            signOptions: [],
            showPopup1: false, // 签名popup
            showPopup2: false, // 通知类型popup
            showPopup3: false,
            haveRange: false, // 发送范围
            columnsNotice: [
                {
                    text: '短信（非员工）',
                    value: 'MsgExternal',
                    disabled: false
                },
                {
                    text: '短信（员工）',
                    value: 'MsgInternal',
                    disabled: false
                },
                {
                    text: '呱呱公众号',
                    value: 'IMChart',
                    disabled: false
                },
                {
                    text: '流程待办任务',
                    value: 'RemindTask',
                    disabled: false
                },
            ], // 通知类型
            columns: [
                {
                    text: '实名',
                    value: 'RealName',
                },
                {
                    text: '匿名',
                    value: 'Anonymous',
                },
            ],
            isCustomLeft: false,
            smsContentList: [
                {
                    "fieldCode": "phone",
                    "fieldName": "{$phone}手机号",
                    "enabled": "1"
                }, {
                    "fieldCode": "ext2",
                    "fieldName": "{$ext2}扩展字段2",
                    "enabled": "1"
                }, {
                    "fieldCode": "ext3",
                    "fieldName": "{$ext3}扩展字段3",
                    "enabled": "1"
                }, {
                    "fieldCode": "ext4",
                    "fieldName": "{$ext4}扩展字段4",
                    "enabled": "1"
                }, {
                    "fieldCode": "pageUrl",
                    "fieldName": "{$pageUrl}问卷链接",
                    "enabled": "1"
                }
            ],
        }
    },
    mixins: [mixin],
    components: { 
        confirm, 
        [Cell.name]: Cell,
        [CellGroup.name]: CellGroup,
    },
    computed: {
        columnsSign() {
            let obj = this.signOptions.find(item => item.dicValue === this.signType.value)
            if(obj){
                this.signType.text = obj.dicKey
            } else {
                this.signType.text = '【瓜子二手车】'
            }
            return this.signOptions.map(item => ({
                value: item.dicValue,
                text: item.dicKey,
                ...item,
            }))
        },
        pageId() {
            return this.$route.params.pageId
        },
        query() {
            return this.$route.query
        },
        requestData() {
            return {
                tid: this.tid,
                pageId: this.pageId,
            }
        },
    },
    created() {
        this.getSignOptions()
        this.handlePublishData()
        const { guaguaApp } = browser
        this.isCustomLeft = guaguaApp
        // this.$router.push({name: 'index'})
    },
    mounted() {
        let that = this
      if (/Android/gi.test(navigator.userAgent)) {
          // 如果是安卓用户，则需要做处理
          NativeApi.register('back', (data, responseCallback) => {
            responseCallback('{preventDefault: true}') // 阻止默认返回事件
            that.$router.replace({name: 'mine'})

          })
      } else {
          NativeApi.register('back', (data, responseCallback) => {
            responseCallback({ 'preventDefault': true }) // 阻止默认返回事件
            that.$router.replace({name: 'mine'})
          })
      }
    },
    methods: {
        onChange(value) {
            if (!value) return
            if (value === 'RealName') {
                this.$set(this.columnsNotice[0], 'disabled', true)
                this.$set(this.columnsNotice[3], 'disabled', false)
                if (this.notice.value === 'MsgExternal') {
                    this.$set(this.notice, 'value', '')
                    this.$set(this.notice, 'text', '未设置')
                }
            } else {
                this.$set(this.columnsNotice[0], 'disabled', false)
                this.$set(this.columnsNotice[3], 'disabled', true)
                if (this.notice.value === 'RemindTask') {
                    this.$set(this.notice, 'value', '')
                    this.$set(this.notice, 'text', '未设置')
                }
            }
        },
        dialogConfirm() {
            this.$store.commit('removeRangeList')
            this.$store.commit('removePublishData')
            this.$router.push({
                name: 'notice',
                params: {
                    pageId: this.pageId
                },
                query: {
                    active: 1
                }
            })
        },
        dialogCancel() {
            this.$store.commit('removeRangeList')
            this.$store.commit('removePublishData')
            this.$router.push({
                name: 'mine'
            })
        },
        insert(value) {
            value = `{{${value}}}`
            let myField = document.getElementsByClassName('me-field__control')[0]
            if (myField.selectionStart || myField.selectionStart === 0) {
                let startPos = myField.selectionStart
                let endPos = myField.selectionEnd
                this.smsContent = myField.value.substring(0, startPos) + value + myField.value.substring(endPos, myField.value.length)
                this.$nextTick(()=>{
                    myField.focus()
                    myField.setSelectionRange(endPos + value.length, endPos + value.length)
                })
            } else {
                this.smsContent += value
            }
        },
        showTip() {
            const message = `<div style="text-align:left;color:#333;font-size: .37rem;">1、手机号/UserId、扩展字段2、扩展字段3、扩展字段4，来源于导入模板中的数据；\n2、用户收到的问卷链接，是针对每个手机号/扩展字段生成的唯一问卷链接，便于后期统计分析用；\n3、短信发送速度预计150/分钟；\n4、发送名单支持导入excel表、接口调用；\n5、根据公司安全要求，【扩展字段ext1】中可填写userId或C01的密文手机号，不支持：明文、V1/V2格式的手机号；\n6、若接口调用，请参考：<a href="http://cwiki.guazi.com/pages/viewpage.action?pageId=250233766" style="color: #06B455;">http://cwiki.guazi.com/pages/viewpage.action?pageId=250233766</a>。</div>`
            Dialog.alert({
                title: '',
                message,
                }).then(() => {
            })
        },
        showPopSign() {
            this.showPopup3 = true 
        },
        getSignOptions() {
            return Questionnaire.getSignType({
                 tid: this.tid,
            }).then((res)=>{
                const {code, message, data} = res.data
                if(code === 'S00000'){
                    this.signOptions = data
                    return
                }
                Toast.fail(message)
            })
        },
        handlePublishData() {
            let publish = this.$store.state.publishData
            if (publish.pageId === this.pageId && this.query.updateRange == '1') {
                this.anonymous.value = publish.loginType || ''
                this.anonymous.text = publish.loginTypeName || '未设置'
                this.notice.value = publish.sendType || 'MsgExternal'
                this.notice.text = publish.sendTypeName || '短信（非员工）'
                this.haveRange = publish.haveRange
                this.customSignId = publish.customSignId
                if (publish.signType === 'user_custom') {
                    this.smsContentList = publish.smsContent
                } else {
                    this.smsContent = publish.smsContent
                }
                this.signType.value = publish.signType || 'ws5d80a67708bd4'
                this.signType.text = publish.signTypeName || '【瓜子二手车】'
                this.onChange(this.anonymous.value)
                if (this.$store.state.rangeList.length > 0) {
                    this.haveRange = true
                } else {
                    this.haveRange = false
                    this.$store.commit('removeRangeList')
                }
            } else {
                this.$store.commit('removePublishData')
                this.$store.commit('removeRangeList')
                this.getQuestionConfig()
            }
            removeClass2('body', 'loading')
        },
        getdefaultIndex(type, value) {
            let list = []
            if (type === 'anonymous') {
                list = this.columns
            } else if (type === 'notice') {
                list = this.columnsNotice
            } else {
                list = this.columnsSign
            }
            return list.findIndex(item => item.value === value) || 0
        },
        showPop(val) {
            if (val === 'anonymous') {
                this.showPopup1 = true
            } else {
                this.showPopup2 = true
            }
        },
        jump() {
            let publishData = {
                pageId: this.pageId,
                customSignId: this.customSignId,
                loginType: this.anonymous.value,
                loginTypeName: this.anonymous.text || '未设置',
                sendType: this.notice.value || 'MsgExternal',
                sendTypeName: this.notice.text || '短信（非员工）',
                haveRange: this.haveRange,
                smsContent: this.signType.value === 'user_custom' ? this.smsContentList : this.smsContent,
                signType: this.signType.value || 'ws5d80a67708bd4',
                signTypeName: this.signType.text || '【瓜子二手车】'
            }
            this.$store.commit('updatePublishData', publishData)
            this.$router.push({
                name: 'sendingRange',
                params: {
                    pageId: this.pageId,
                },
                query: {
                    updateRange: this.query.updateRange || '0'
                }
            })
        },
        confirm() {
            if (!this.notice.value) {
                Toast.fail('请设置通知类型')
                return
            }
            if (this.anonymous.value === 'Anonymous' && !this.haveRange && (this.notice.value === 'MsgInternal' || this.notice.value === 'IMChart') ) {
                Toast.fail('请指定发送范围')
                return
            }
            if (this.anonymous.value === 'RealName' && !this.haveRange) {
                Toast.fail('请指定发送范围')
                return
            }
            if (this.signType.value === 'user_custom') {
                if ( !this.customSignId) {
                    Toast.fail('请填写模版服务ID')
                    return true
                }
            } else {
                if (this.notice.value !== 'RemindTask' && (!this.smsContent || (this.smsContent && !this.smsContent.trim()))) {
                    Toast.fail(`${this.notice.text}内容不能为空，请先添加${this.notice.text}内容`)
                    return true
                }
                if ((this.notice.value !== 'RemindTask' && this.notice.value !== 'IMChart') && /\n|\"/.test(this.smsContent)) {
                    Toast.fail('短信内容不能包含换行、英文双引号特殊字符')
                    return true
                }
            }
            let rangeList = this.$store.state.rangeList
            if (this.notice.value === 'MsgExternal') {
                rangeList = []
            }
            let smsContentListStr = ''
            if (this.signType.value === 'user_custom') {
                let smsContentList = this.smsContentList.map(item => {
                    return {
                        fieldCode: item.fieldCode,
                        enabled: item.enabled,
                    }
                })
                smsContentListStr = JSON.stringify(smsContentList)
            }
            const data = {
                pageId: this.pageId,
                loginType: this.anonymous.value,
                sendType: this.notice.value,
                rangeList,
                customSignId: this.customSignId,
                smsContent: smsContentListStr || this.smsContent,
                signType: this.signType.value
            }
            addClass2('body', 'loading')
            Questionnaire.publishSave(data, this.tid).then((res) => {
                removeClass2('body', 'loading')
                if (this.notice.value === 'MsgExternal') {
                    this.questionPublish()
                    return
                }
                this.publish()
            }).catch((error) => {
                removeClass2('body', 'loading')
                Toast.fail(error.response.data.message)
            })
        },
        publish() {
            this.dialogShow = true
            this.showBtn = false
            this.dialogMsg = '保存成功，正在发送中，请您稍候...'
            Questionnaire.questionPublish(this.requestData).then(res => {
                if (res.data.code == 'S00000') {
                    this.getInternal()
                } else {
                    Toast.fail(res.data.message)
                    this.dialogShow = false
                }
            }).catch((error) => {
                Toast.fail(error.response.data.message)
                this.dialogShow = false
            })
        },
        questionPublish() {
            return Questionnaire.questionPublish(this.requestData).then(res => {
                removeClass2('body', 'loading')
                if (res.data.code == 'S00000') {
                    Toast.success('发布成功')
                    this.$store.commit('removeRangeList')
                    this.$store.commit('removePublishData')
                    this.$router.push({
                        name: 'mine'
                    })
                } else {
                    Toast.fail(res.data.message)
                }
            }).catch((error) => {
                removeClass2('body', 'loading')
            })
        },
        getInternal() {
            let data = {
                tid: this.tid,
                pageId: this.pageId,
                smsContent: this.smsContent,
                signType: this.signType.value,
                sendType: this.notice.value
            }
            Questionnaire.getInternal(data, this.tid).then(res => {
                this.showBtn = true
                this.dialogMsg = '发送成功！您可以在通知发送记录中查看本次发送详细记录。'
            }).catch((error) => {
                console.log(error.response.data)
                this.dialogShow = false
                if (error.response.data.code === 'E13003') {
                    Toast.fail(error.response.data.message || '消息发送目标人群为空！')
                } else {
                    Toast.fail('发送失败！您可以在通知发送记录中查看具体失败原因。')
                }
            })
        },

        getQuestionConfig() {
            return Questionnaire.getQuestionConfig({
                tid: this.tid,
                pageId: this.pageId,
            }).then((res)=>{
                const { code, data } = res.data
                removeClass2('body', 'loading')
                if(code === 'S00000'){
                    this.anonymous.value = data.loginType || ''
                    this.anonymous.text = data.loginTypeName || '未设置'
                    this.notice.value = data.sendType || 'MsgExternal'
                    this.notice.text = data.sendTypeName || '短信（非员工）'
                    this.haveRange = data.haveRange
                    if (data.signType === 'user_custom' && (data.sendType == 'MsgExternal' || data.sendType === 'MsgInternal')) {
                        this.customSignId = data.customSignId
                        let smsContentList = JSON.parse(data.smsContent)
                        this.smsContentList.forEach(item => {
                            smsContentList.forEach(obj => {
                                if (item.fieldCode === obj.fieldCode) {
                                    item.enabled = obj.enabled
                                }
                            })
                        })
                    } else {
                        this.smsContent = data.smsContent
                    }
                    this.signType.value = data.signType || 'ws5d80a67708bd4'
                    this.onChange(this.anonymous.value)
                    if (this.haveRange) {
                        this.getAuthority()
                    }
                    return
                }
            }).catch((error) => {
                removeClass2('body', 'loading')
                console.log(error.response)
                Toast.fail(error.response.data.message)
            })
        },
        showTipDesc() {
            const message = `<div style="text-align:left;color:#333;font-size: .37rem;">短信平台模板配置提示：\n地址：\n<a href="https://pangu.guazi-apps.com/sms-service-kcp/sms_template" style="color: #06B455;">https://pangu.guazi-apps.com/sms-service-kcp/sms_template</a>。\n若无权限，先申请【短信平台】权限。\n地址：\n<a href="https://spc.guazi-apps.com/#/apply/edit?permissionType=0" style="color: #06B455;">https://spc.guazi-apps.com/#/apply/edit?permissionType=0</a>。\n详细配置地址：\n<a href="https://cwiki.guazi.com/pages/viewpage.action?pageId=561291753" style="color: #06B455;">https://cwiki.guazi.com/pages/viewpage.action?pageId=561291753</a>。\n\n模板示例：\n参与调研得10元用户回访金！了解您在瓜子卖车的服务感受，帮助我们提供更好的服务，感谢您的反馈！（用户回访金预计在调研结束后的7个工作日内发放）{$pageUrl}</div>`
            Dialog.alert({
                title: '',
                message,
                }).then(() => {
            })
        },
        getAuthority() {
            addClass2('body', 'loading')
            const data = {
                tid: this.tid,
                pageId: this.pageId,
            }
            Questionnaire.getAuthority(data).then((res) => {
                const { code, data } = res.data
                removeClass2('body', 'loading')
                if (code == 'S00000') {
                    this.$store.commit('saveRangeList', data)
                }
            }).catch((error) => {
                removeClass2('body', 'loading')
                console.log(error.response)
                Toast.fail(error.response.data.message)
            })
        },
        onConfirmPicker(data, type) {
            if (type === 'anonymous') {
                this.anonymous = {...data}
                this.onChange(this.anonymous.value)
            } else if (type === 'notice') {
                this.notice = {...data}
            } else {
               this.signType = {...data}
            }
            this.showPopup1 = false
            this.showPopup2 = false
            this.showPopup3 = false
        },
        onCancelPicker() {
            this.showPopup1 = false
            this.showPopup2 = false
            this.showPopup3 = false
        },
    },
}
</script>
<style scoped lang="scss">
    .desc-tip {
        padding: 0 0.42667rem 0.2rem;
        color: rgba(69, 90, 100, 0.6);
        font-size: 0.32rem;
        background: #fff;
    }
    .defined-field {
        ::v-deep .me-field__control {
            background-color: #fff;
        }
    }
    .defined-span {
        padding: 0.26667rem 0.42667rem;
        font-size: 0.31rem;
    }
    .dialog_msg {
        padding: 14px;
        text-align: center;
    }
    .notice-content{
        padding-bottom: 2.66667rem;
        .types{
            display: flex;
            justify-content: space-between;
            margin: 0.3rem .53rem;
        }
        .send-tip{
            padding: 0 0.42rem 0.1rem;
            font-size: .43rem;
            text-decoration: underline;
            .info-o{
                vertical-align: -.08rem;
                font-size: .43rem;
                margin-right: .1rem;
            }
        }
        .content{
            padding: .42rem;
            font-size: 0.37333rem;
            background: #fff;
            .texts{
                margin: .4rem 0;
                display: flex;
                justify-content: space-between;
                >span{
                    cursor: pointer;
                    text-decoration: underline;
                    color: #06B455;
                }
            }
            .tip{
                margin-top: .5rem;
                margin-bottom: .2rem;
                color: rgba(69, 90, 100, 0.6);
                font-size: .32rem;
                &::before{
                    content: '';
                    display: inline-block;
                    margin-right: .1rem; 
                    width: .32rem;
                    height: .32rem;
                    background: url(../images/warning.png) no-repeat;
                    background-size: cover;
                    vertical-align: -.03rem;
                }
                // >span{
                //     color: #2c3e50;
                // }
            }
        }
        .not-yet{
            opacity: 0;
        }
    }
    .dialog-content{
        padding: .3rem;
        .import-btn{
            display: inline-block;
            padding: 0.2rem 0.5rem;
            width: 2.6rem;
            border: 0.02667rem solid #06B455;
            border-radius: 0.1rem;
            font-size: 0.37rem;
            box-sizing: border-box;
            text-align: center;
        }
        .down{
            margin-left: 1rem;
            color: #06B455;
            text-decoration: underline;
            font-size: .37rem;
        }
        .notice{
            display: flex;
            font-size: .32rem;
            margin: 0.6rem 0 .2rem;
            color: #5F6670;
        }
        .file{
            margin-bottom: .6rem;
            display: flex;
            justify-content: space-between;
            font-size: 0.37rem;
            .fileName{
                flex: 1;
            }
            .del{
                display: inline-block;
                margin-left: .5rem;
                width: 1rem;
                text-decoration: underline;
            }
        }
    }
    .defined-group{
        &:after{
            border-top: none;
        }
    }
    .defined-cell{
        margin-bottom: 10px;
        i[class^="me-icon"]{
            top: 5px;
        }
    }
    ::v-deep .me-cell:not(.defined-cell){
        padding: 0;
    }
    ::v-deep .me-cell::after{
        border: none;
    }
    ::v-deep .me-field__body{
        border-radius: .1rem;
        background: #F6F6F6;
    }
    ::v-deep .me-field__control{
        padding: .1rem;
    }
</style>
